import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Elements, StripeProvider } from 'react-stripe-elements';
import { Alert } from '@surfline/quiver-react';
import { OfferForm } from '../../containers';
import {
  OfferDetails,
  OfferLoading,
  OfferError,
} from '../../components';
import { startSubmitSpinner } from '../../redux/actions/interactions';
import { fetchOffer, acceptOffer } from '../../redux/actions/offer';
import { setSelectedCardSource, toggleShowCards } from '../../redux/actions/cards';
import { getCreditCards, getDefaultSource, getSelectedCard } from '../../selectors/cards';
import config from '../../config';

class OfferPaymentWrapper extends Component {
  async componentDidMount() {
    const { doFetchOffer, viewedCheckout } = this.props;
    await doFetchOffer();
    viewedCheckout();
  }

  submitPaymentForm = async (values) => {
    const {
      doAcceptOffer,
      defaultCardId,
      brand,
    } = this.props;
    const promotionId = config.funnelConfig._id;
    const acceptOfferValues = {
      ...values,
      brand,
      promotionId,
      defaultCardId,
    };
    await doAcceptOffer(acceptOfferValues);
  }

  render() {
    const {
      children,
      isEligible,
      offerDetails,
      cards,
      loading,
      submitting,
      defaultCardId,
      selectedCard,
      showCards,
      doSetSelectedCardSource,
      doToggleShowCards,
      doStartSubmitSpinner,
      cardError,
      offerError,
    } = this.props;

    if (isEligible === false) {
      return <OfferError error={offerError} />;
    }

    const {
      funnelConfig: {
        buttonText
      }
    } = config;
    const error = cardError || offerError;
    if (isEligible && !loading) {
      return (
        <div>
          {error
            ? <Alert type="error">{error}</Alert>
            : null
          }
          {children}
          <div>
            <OfferDetails details={offerDetails} />
          </div>
          <StripeProvider apiKey={config.stripe.publishableKey}>
            <div>
              <Elements>
                <OfferForm
                  buttonText={buttonText}
                  offerDetails={offerDetails}
                  isEligible={isEligible}
                  submitting={submitting}
                  paymentHandler={this.submitPaymentForm}
                  triggerSubmit={doStartSubmitSpinner}
                  cards={cards}
                  showCards={showCards}
                  defaultCardId={defaultCardId}
                  selectedCard={selectedCard}
                  doSetSelectedCardSource={doSetSelectedCardSource}
                  doToggleShowCards={doToggleShowCards}
                  error={offerError || cardError}
                />
              </Elements>
            </div>
          </StripeProvider>
        </div>
      );
    }
    return (<OfferLoading />);
  }
}

OfferPaymentWrapper.propTypes = {
  offerDetails: PropTypes.shape(),
  cardError: PropTypes.shape(),
  cards: PropTypes.arrayOf(PropTypes.shape()),
  offerError: PropTypes.shape(),
  isEligible: PropTypes.bool,
  submitting: PropTypes.bool,
  showCards: PropTypes.bool,
  brand: PropTypes.string.isRequired,
  defaultCardId: PropTypes.string,
  selectedCard: PropTypes.string,
};
OfferPaymentWrapper.defaultProps = {
  offerDetails: null,
  cardError: null,
  offerError: null,
  cards: null,
  isEligible: null,
  submitting: false,
  showCards: false,
  defaultCardId: null,
  selectedCard: null,
};

export default connect(
  state => ({
    brand: state.brand,
    offerDetails: state.offer.details,
    isEligible: state.offer.isEligible,
    submitting: state.interactions.submitting,
    cards: getCreditCards(state),
    defaultCardId: getDefaultSource(state),
    selectedCard: getSelectedCard(state),
    showCards: state.cards.showCards,
    cardError: state.cards.error,
    offerError: state.offer.error,
  }),
  dispatch => ({
    doFetchOffer: () => dispatch(fetchOffer()),
    doAcceptOffer: values => dispatch(acceptOffer(values)),
    doStartSubmitSpinner: () => dispatch(startSubmitSpinner()),
    doSetSelectedCardSource: cardId => dispatch(setSelectedCardSource(cardId)),
    doToggleShowCards: showCards => dispatch(toggleShowCards(showCards)),
  }),
)(OfferPaymentWrapper);
